import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {Props} from './types';

import {Clickable} from '../../../../uikit/Clickable';
import {ListItem} from '../../components/ListItem';
import {CountryModel} from './model';

export const CountriesListItem = observer<Props>(
  ({country, onClick, ...rest}) => {
    const model = useMemo(() => new CountryModel(country), [country]);

    const onClickCb = useCallback(() => {
      onClick(country);
    }, [country, onClick]);

    return (
      <Clickable onClick={onClickCb} {...rest}>
        <ListItem code={model.code} name={model.name} />
      </Clickable>
    );
  },
);
